module.exports = __webpack_public_path__ + "static/img/haoyou.2ae6d444.png";